export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/dashboard/home/Home.vue'),
  },
  {
    path: '/staffing',
    name: 'staffing-dashboard',
    component: () => import('@/views/dashboard/staffing/Staffing.vue'),
    meta: {
      rights: ['STAFFING:read'],
    },
  },
]
